import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'markdownParsers'
})
export class MarkdownParsersPipe implements PipeTransform {
    constructor() { }
    transform(value: any, args?: any): any {
        if (!value) return '';
        return value.replace(/\*/g, "");
    }

}
